export const tokensMeta: Record<
  string,
  { decimals: number; logoURI: string } | undefined
> = {
  USDe: {
    decimals: 18,
    logoURI: "/tokens/USDe.svg",
  },
  USDC: {
    decimals: 6,
    logoURI: "/tokens/USDC.svg",
  },
  USDM: {
    decimals: 18,
    logoURI: "/tokens/USDM.svg",
  },
  USDT: {
    decimals: 6,
    logoURI: "/tokens/USDT.svg",
  },
  USDS: {
    decimals: 18,
    logoURI: "/tokens/USDS.svg",
  },
  // LP
  sUSDe: {
    decimals: 18,
    logoURI: "/tokens/sUSDe.svg",
  },
  sUSDS: {
    decimals: 18,
    logoURI: "/tokens/sUSDS.svg",
  },
  steakUSDC: {
    decimals: 18,
    logoURI: "/tokens/steakUSDC.svg",
  },
  BORING: {
    decimals: 18,
    logoURI: "/bento-usd-token.svg",
  },
};
